import {connect, Store as ReduxStore} from "react-redux";
import {State} from "./reducers";
import {ArticleTemplateList, CallbackProps, ValueProps} from "./presentation";
import {maxPrioritiesFromList} from "./data";
import {compose, Dispatcher, objToList} from "../../../lib/utils";
import {Action} from "redux";
import {ListAction, ListActionWrapper} from "./actions";
import {CommandCaller} from "../../../lib/commands";
import {redirect} from "../../../common/common";
import {
	ArticleTemplateFromPHP,
	Column,
	restrictColumn,
	sortByColumnAndPriority
} from "../data";

export type Store = ReduxStore<State>

export type OwnProps = {
	store: Store
	columns: Column
	templateId: string
	ajaxPageUrl: string
	editArticleTemplatePageUrl: string
}

const mapStateToProps = (state: State, ownProps: OwnProps): ValueProps => {
	const articleTemplates = objToList(restrictColumn(ownProps.columns), state.layout).sort(sortByColumnAndPriority)

	return {
		articleTemplates: articleTemplates,
		selected: state.selected,
		columns: ownProps.columns,
		priorities: maxPrioritiesFromList(articleTemplates),
		canEdit: state.toolbar.canEdit,
		canMulti: state.toolbar.canMulti
	}
}

const mapDispatchToProps = (dispatch: Dispatcher<Action, State>, ownProps: OwnProps): CallbackProps => {
	const wrap = (action: ListAction): ListActionWrapper => ({
		type: 'list action',
		action: action
	})
	const dispatchAction = compose(wrap, dispatch)

	return {
		selectAll: () => dispatchAction({type: 'select all article templates'}),
		unselectAll: () => dispatchAction({type: 'unselect all article templates'}),
		select: (id) => dispatchAction({type: 'select article template', id: id}),
		unselect: (id) => dispatchAction({type: 'unselect article template', id: id}),
		changeColumn: (id, column) => dispatchAction({type: 'change column', id: id, column: column}),
		changePriority: (id, priority) => dispatchAction({type: 'change priority', id: id, priority: priority}),
		addArticle: () => redirect({pageUrl: ownProps.editArticleTemplatePageUrl}),
		editArticle: (id) => redirect({pageUrl: `${ownProps.editArticleTemplatePageUrl}/${id}`}),
		editSelectedArticle: () => dispatch(async (dispatchUnwrapped, getState) => {
			const id = getState().selected[0]
			redirect({pageUrl: `${ownProps.editArticleTemplatePageUrl}/${id}`})
		}),
		copyArticles: () => dispatch(async (dispatchUnwrapped, getState) => {
			const s = getState()
			const r = await new CommandCaller(ownProps.ajaxPageUrl).runPost(
				'copy article templates', {templateId: ownProps.templateId, ids: s.selected}
			) as {copiedArticleTemplates: ArticleTemplateFromPHP[]}
			dispatchAction({type: 'add copied article templates', copiedArticleTemplates: r.copiedArticleTemplates})
		}),
		deleteArticles: () => dispatch(async (dispatchUnwrapped, getState) => {
			const s = getState()
			const plural = s.selected.length > 1 ? 's' : '';
			if(confirm(`Are you sure you want to permanently delete the selected article template${plural}?`)) {
				await new CommandCaller(ownProps.ajaxPageUrl).runPost(
					'delete article templates', {templateId: ownProps.templateId, ids: s.selected}
				)
				dispatchAction({type: 'delete article templates', deletedArticleTemplateIds: s.selected})
			}
		})
	}
}

export const ArticleTemplateListApp = connect<ValueProps, CallbackProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps
)(ArticleTemplateList)



// WEBPACK FOOTER //
// ./src/communications/article-templates/writable/app.ts